const url = 'igss-forms';
import { api } from 'api';
import Swal from 'sweetalert2';
import { push } from 'react-router-redux';
import { goBack } from 'react-router-redux';
import { initialize as initializeForm } from 'redux-form';
import { createActions, handleActions } from 'redux-actions';
import moment from "moment";

import { actions as saleActions } from '../sales';

const LOADER_REPORT_IGSS = 'LOADER_REPORT_IGSS';
const SET_DATA_REPORT_IGSS = 'SET_DATA_REPORT_IGSS';
const SET_PAGE_REPORT_IGSS = 'SET_PAGE_REPORT_IGSS';
const SET_BUSCADOR_REPORT_IGSS = 'SET_BUSCADOR_REPORT_IGSS';
const SET_FILTRO_REPORT_IGSS = 'SET_FILTRO_REPORT_IGSS';
const SET_INICIAL_DATE_REPORT_IGSS = 'SET_INICIAL_DATE_REPORT_IGSS';
const SET_FINAL_DATE_REPORT_IGSS = 'SET_FINAL_DATE_REPORT_IGSS';
const SET_SALDO_TOTAL = 'SET_SALDO_TOTAL';
const CHANGE_SELECT_FILTER = 'CHANGE_SELECT_FILTER';
const LOADER_EXCEL_REPORTE_IGSS = "LOADER_EXCEL_REPORTE_IGSS";
const SET_IGSS_CODE = "SET_IGSS_CODE";
const SET_IGSS_PROCEDURES = "SET_IGSS_PROCEDURES";
const SET_IGSS_PROCEDURE_CODE = "SET_IGSS_PROCEDURE_CODE";

const listar = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_REPORT_IGSS, cargando: true});
    const store = getStore();
    const search = store.general_report_form.buscador;
    const filtro = store.general_report_form.filtro;
    const initial_date = store.general_report_form.initial_date;
    const final_date = store.general_report_form.final_date;
    const select_search = store.general_report_form.select_search;
    const igss_code = store.general_report_form.igss_code; 
    let params;

    if(!!initial_date && !!final_date){
        params = {page, search, select_search, igss_code, initial_date, final_date};
    }else{
        params = {page, search, select_search, igss_code};
    }
    if(filtro){
        params[''] = filtro
    }    

    api.get(`${url}/igssReport`, params).catch((error) => {
        dispatch({type: LOADER_REPORT_IGSS, cargando: false});
        Swal(
            'Error',
            error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            console.log("DATA DEL REPORTE GENERAL IGSS .:::: ... :::: ", data);
            dispatch({type: SET_DATA_REPORT_IGSS, data});

            let total = 0;
            data.forEach(i => {
                if(i.procedure){
                    total += parseFloat(i.procedure.price);
                }
            })

            dispatch({type: SET_SALDO_TOTAL, saldo_total: total });
        }
    }).finally(()=>{
        dispatch({type: LOADER_REPORT_IGSS, cargando: false});
    })
};

const getCodeProcedures = (page = 1) =>  (dispatch, getStore) => {
    api.get("igss-procedures", {page}).catch((error) => {})
    .then((data) => {
        if (data){
            const procedures = [];
            data.results.forEach(x=>{                    
                procedures.push({value: x.id, label: x.name + " " + `(${x.code})`, code: x.code })
            })
            
            dispatch({ type: SET_IGSS_PROCEDURES, procedures });
        }
    })
    .catch(e => {
        console.log("No se obtuvieron datos... ", e)
        return []
    })
}

const changeFilter = (option) => (dispatch) => {
    dispatch({type: CHANGE_SELECT_FILTER, select_search: option});
    dispatch(listar(1));
};

const search = (search) => (dispatch) => {    
    dispatch({type: SET_BUSCADOR_REPORT_IGSS, buscador: search});
    dispatch(listar(1));
};

const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_REPORT_IGSS, filtro});
    dispatch(listar(1));
};

const setFinalDate = (value) => (dispatch) => {
    console.log("final date value .:: ", value);
    dispatch({type: SET_FINAL_DATE_REPORT_IGSS, final_date: value});    
    // dispatch(listar(1));
}

const setInitialDate = (value) => (dispatch) => {
    console.log("initial date value .:: ", value);
    dispatch({type: SET_INICIAL_DATE_REPORT_IGSS, initial_date: value});
    // dispatch(listar(1));
}

const openAccount = (id) => (dispatch, getStore) => {
    dispatch(saleActions.openAccount(id));
}

const cancelOpenAccount = (id) => (dispatch, getStore) => {
    dispatch(saleActions.cancelOpenAccount(id));
}

const setLoaderExcel = (value) => (dispatch) => {
    dispatch({
        type: LOADER_EXCEL_REPORTE_IGSS,
        cargandoExcel: value,
    });
};

const setIgssCode = (value) => (dispatch, getStore) => {
    const store = getStore();
    dispatch({
        type: SET_IGSS_CODE,
        igss_code: value,
    });

    const procedure_code = store.general_report_form.procedures.find(p => p.value == value)
    if(procedure_code){
        dispatch({
            type: SET_IGSS_PROCEDURE_CODE,
            procedure_code: procedure_code.code
        });
    }

    dispatch(listar(1));
};

export const generarExcelReporteIgss = () => (dispatch, getStore) => {
    dispatch(setLoaderExcel(true));
 
    let endpoint = `/api/${url}/export_to_excel_igss_report/`;
    const regexFecha = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
 
    if (
        getStore().general_report_form.initial_date &&
        getStore().general_report_form.final_date &&
        regexFecha.test(getStore().general_report_form.initial_date) &&
        regexFecha.test(getStore().general_report_form.final_date)
    ) {
        endpoint += `?initial_date=${getStore().general_report_form.initial_date}`;
        endpoint += `&final_date=${getStore().general_report_form.final_date}`;
    } else {
        Swal.fire(
            "Error",
            "Debe seleccionar ambas fechas para generar el reporte",
            "error"
        );
        dispatch(setLoaderExcel(false));
        return;
    }

    const search = getStore().general_report_form.buscador;
    const filtro = getStore().general_report_form.filtro;
    const igss_code = getStore().general_report_form.igss_code;

    const params = {
        search,
        filtro,
        igss_code
    };

    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            const element = params[key];
            if (element) {
                endpoint += `&${key}=${element}`;
            }
        }
    }

    fetch(endpoint, {
        method: "GET",
        headers: {
            Authorization: `Token ${localStorage.getItem("token")}`,
        },
    })
    .then((response) => {        
        Swal(
            'success',
            "Se está generando el archivo, puede ir a la sección de tareas para ver el estado del reporte",
            'success'
        );        
    })
    .catch(() => {
        Swal(
            'Error',
            error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );        
    })
    .finally(() => {
        //dispatch(setLoaderExcel(false));
    });
};

export const actions = {
    listar,
    search,
    filtro,
    setFinalDate,
    setInitialDate,

    openAccount,
    cancelOpenAccount,
    changeFilter,
    generarExcelReporteIgss,
    setIgssCode,
    getCodeProcedures
};

export const reducer = {
    [LOADER_REPORT_IGSS]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_REPORT_IGSS]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_REPORT_IGSS]: (state, { page }) => {
        return {...state, page }
    },
    [SET_BUSCADOR_REPORT_IGSS]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_REPORT_IGSS]: (state, { filtro }) => {
        return {...state, filtro }
    },
    [CHANGE_SELECT_FILTER]: (state, { select_search }) => {
        return {...state, select_search }
    },    
    [SET_INICIAL_DATE_REPORT_IGSS]: (state, { initial_date }) => {
        return{
            ...state,
            initial_date
        }
    },
    [SET_FINAL_DATE_REPORT_IGSS]: (state, { final_date }) => {
        return{
            ...state,
            final_date
        }
    },
    [SET_SALDO_TOTAL]: (state, { saldo_total }) => {
        return{
            ...state,
            saldo_total
        }
    },    
    [LOADER_EXCEL_REPORTE_IGSS]: (state, { cargandoExcel }) => {
        return { ...state, cargandoExcel };
    },
    [SET_IGSS_CODE]: (state, { igss_code }) => {
        return { ...state, igss_code };
    },
    [SET_IGSS_PROCEDURES]: (state, { procedures }) => {
        return { ...state, procedures };
    }, 
    [SET_IGSS_PROCEDURE_CODE]: (state, { procedure_code }) => {
        return { ...state, procedure_code };
    },    
};

export const initialState = {
    cargando: false,
    page: 1,
    data: [],
    buscador: '',
    filtro: null,
    select_search: 0,    
    initial_date: null,
    final_date: null,
    entry_movement: null,
    igss_code: 0,
    saldo_total: 0,
    cargandoExcel: false,
    procedures: [],
    procedure_code: null
};

export default handleActions(reducer, initialState)
